/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
import {
  Flexbox, Form, LoadManager,
} from '@/components'
import useMistreatment from '@/hooks/useMistreatment'
import usePageTitle from '@/hooks/usePageTitle'
import { MISTREATMENT } from '@/lib/enums'
import yup from '@/lib/yupPt'
import { setMistreatment } from '@/reducers/mistreatment'
import mistreatments from '@/services/api/mistreatments'
import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

const schema = yup.object().shape({
  description: yup.string().trim(),
  result: yup.string().trim().required(),
})
function Done({ title }) {
  usePageTitle({ title })
  const [loading, setLoading] = useState(false)
  const { id } = useParams()
  const { state: { mistreatment }, dispatch } = useMistreatment()
  const history = useHistory()

  async function onSubmit(values) {
    try {
      setLoading(true)
      const { data } = await mistreatments.done(id, values)
      dispatch(setMistreatment(data))
      toast.success('Denúncia concluída')
      setLoading(false)
      history.goBack()
    } catch (e) {
      setLoading(false)
      toast.error(e?.message)
    }
  }

  return (
    <fieldset disabled={loading}>
      <div className="modal active" id="modal-id">
        <a type="button" className="modal-overlay" aria-label="Close" onClick={() => history.goBack()} />
        <div className="modal-container">
          <div className="modal-header">
            <a
              type="button"
              className="btn btn-clear float-right"
              onClick={() => history.goBack()}
            />
            <div className="modal-title h5">Concluir denúncia #{id}</div>
          </div>
          <div className="modal-body">
            <div className="content">
              <LoadManager loading={!mistreatment}>
                <>
                  <div className="mb-1">Confirma a conclusão desta denúncia?</div>
                  <div className="text-small mb-1">
                    Após isso a denúncia será concluída, este processo não é reversível.
                  </div>
                  <Form.Formik
                    initialValues={{
                      description: '',
                      result: '',
                    }}
                    validationSchema={schema}
                    onSubmit={onSubmit}
                    validateOnMount
                  >
                    {
                      ({ touched, errors, isValid }) => (
                        <Form.ValidationForm>
                          <Flexbox.Columns>
                            <Flexbox.Column className="col-12">
                              <Form.Group className={`${touched?.description && errors?.description ? 'has-error' : ''}`}>
                                <Form.Label htmlFor="description">Observações</Form.Label>
                                <Form.ValidationField
                                  name="description"
                                  id="description"
                                >
                                  {
                                    ({ field }) => (
                                      <textarea
                                        name="description"
                                        className="form-input"
                                        rows={2}
                                        placeholder="Você pode adicionar alguma observação..."
                                        // eslint-disable-next-line react/jsx-props-no-spreading
                                        {...field}
                                      />
                                    )
                                  }
                                </Form.ValidationField>
                                {
                                  touched?.description && errors?.description
                                    ? <Form.Hint className="text-error">{errors.description}</Form.Hint> : null
                                }
                              </Form.Group>
                            </Flexbox.Column>
                            <Flexbox.Column className="col-12">
                              <Form.Label>Resultado <span className="text-error">*</span></Form.Label>
                              <Form.Label className="form-radio mb-2">
                                <Form.ValidationField
                                  type="radio"
                                  name="result"
                                  value={MISTREATMENT.result.enum.MEASURES_APPLIED}
                                />
                                <i className="form-icon" />
                                &nbsp;Aplicadas as medidas legais
                              </Form.Label>
                              <Form.Label className="form-radio mb-2">
                                <Form.ValidationField
                                  type="radio"
                                  name="result"
                                  value={MISTREATMENT.result.enum.UNFOUNDED}
                                />
                                <i className="form-icon" />
                                &nbsp;Nenhuma irregularidade encontrada
                              </Form.Label>
                            </Flexbox.Column>
                          </Flexbox.Columns>
                          <div className="modal-footer" style={{ paddingLeft: 0, paddingRight: 0 }}>
                            <a
                              className="btn mr-2"
                              disabled={loading}
                              onClick={() => history.goBack()}
                            >
                              <i className="fas fa-chevron-left" />
                              &nbsp;Voltar
                            </a>
                            <button
                              className={`btn btn-primary ${loading ? 'loading' : ''}`}
                              disabled={loading || !isValid}
                              type="submit"
                            >
                              <i className="fas fa-check" />
                              &nbsp;Concluir
                            </button>
                          </div>
                        </Form.ValidationForm>
                      )
                    }
                  </Form.Formik>
                </>
              </LoadManager>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  )
}

export default Done
